import appendEstimateCaveats from "../Services/appendEstimateCaveats";

export default (caveats) => async (dispatch) => dispatch(appendEstimateCaveats(caveats));